import React from 'react';
import NoDataFound from 'Common/NoDataFound';
import useSuperSearchDropdownContext from 'NewComponents/FormComponents/SuperSearchDropdown/useSuperSearchDropdownContext';
import { Tooltip } from 'react-tooltip';
import { LuCornerDownLeft } from 'react-icons/lu';

const PayerSuperSearchTemplate = ({ handleSelectedData, identifier, height = '100%', width = '100%' }) => {
  const { state, onSetSelectedRowNumber, onSetSearchStatus, onSetInputValue, onToggleDropDown, onSetData } = useSuperSearchDropdownContext();
  const { data, selectedRowNumber } = state;

  const handleSingleRow = (row, index) => {
    onSetSelectedRowNumber(index);
    handleSelectedData(row);
    onSetSearchStatus(false);
    onSetInputValue('');
    onToggleDropDown(false);
    onSetData([]);
  };

  return (
    <div
      style={{ height: data.length > 0 ? 'auto' : height, width, minHeight: '10px', maxHeight: '300px', overflow: 'auto' }}
      className='mt-1 rounded-md border bg-white p-1.5 shadow-lg'
    >
      {data.length > 0 ? (
        <div className='space-y-0.5'>
          {data.map((item, index) => {
            const isSelected = index === selectedRowNumber;
            const payerName = item?.payerName ?? item?.name ?? item?.label ?? '';
            // const payerId = item?.payerId ?? '';
            return (
              <div
                key={`${payerName}-${index}`}
                id={`${identifier}_${index}`}
                onClick={() => handleSingleRow(item, index)}
                className={`flex cursor-pointer items-center justify-between text-sm rounded-sm px-2 py-2 transition-colors ${
                  isSelected ? 'bg-[#F3F4F6]' : 'bg-white hover:bg-[#F3F4F7]'
                }`}
              >
                <div
                  className='truncate'
                  data-tooltip-id='payer-supersearch-tooltip'
                  data-tooltip-content={payerName}
                >
                  {payerName}
                </div>
                {isSelected ? <LuCornerDownLeft className='ml-2 shrink-0 text-[#5A5A5A]' size={14} /> : null}
                {/* {payerId ? <div className='truncate opacity-90'>Payer ID: {payerId}</div> : null} */}
              </div>
            );
          })}
        </div>
      ) : (
        <NoDataFound />
      )}
      <Tooltip id='payer-supersearch-tooltip' place='top' />
    </div>
  );
};

export default PayerSuperSearchTemplate;
